import { render, staticRenderFns } from "./ViewGroup.vue?vue&type=template&id=3de7ac03&scoped=true"
import script from "./ViewGroup.vue?vue&type=script&lang=js"
export * from "./ViewGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de7ac03",
  null
  
)

export default component.exports